/* ===========================================================
 * jquery-square_menu.js v1
 * ===========================================================
 * https://github.com/peachananr/square_menu
 * ========================================================== */

!(function ($) {
  var defaults = {
    flyDirection: 'bottom',
    button: 'Menu',
    animationStyle: 'vertical',
    closeButton: 'X',
  };

  $.fn.square_menu = function (options) {
    var settings = $.extend({}, defaults, options),
      el = $(this);

    $('body').addClass('fsm-body');

    el.addClass(
      'sm-menu sm-' + settings.flyDirection + ' sm-' + settings.animationStyle
    );
    el.wrapInner("<div class='sm-wrapper'></div>");

    el.find('nav')
      .addClass('sm-nav')
      .wrapInner("<div class='nav-inner'></div>");

    $.fn.closeMenu = function () {
      $('.sm-menu').addClass('animated').removeClass('re-rotate');
      $('.sm-menu .sm-close').remove();
      $('.sm-menu .sm-nav:first-child .nav-inner').removeClass(
        'animated flyInLeft'
      );
      $('.sm-menu .sm-nav:nth-child(2) .nav-inner').removeClass(
        'animated flyInRight'
      );

      if ($('body').hasClass('sm-activate')) {
        $('.sm-menu').find('.sm-nav').removeClass('animated');
        $('.sm-menu').one(
          'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd',
          function () {
            $('body')
              .removeClass('sm-activate')
              .find('.sm-menu')
              .removeClass('ff-hack');
          }
        );
      }
    };

    $.fn.openMenu = function () {
      $('.sm-menu').addClass('animated').addClass('ff-hack');

      if (!$('body').hasClass('sm-activate')) {
        if ($('.sm-overlay').length < 1)
          $("<div class='sm-overlay'></div>").hide().prependTo('body');
        $('.sm-overlay').fadeIn('fast', function () {
          $('body').addClass('sm-activate');
          var fired = false;
          $('body').one(
            'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd',
            function (e) {
              if (!fired) {
                fired = true;
                $('.sm-menu .sm-nav').addClass('animated');
                $('.sm-menu .sm-nav').one(
                  'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd',
                  function (e) {
                    if (
                      e.originalEvent.propertyName === '-webkit-transform' ||
                      e.originalEvent.propertyName === 'transform' ||
                      e.originalEvent.propertyName === '-o-transform' ||
                      e.originalEvent.propertyName === '-moz-transform'
                    ) {
                      $('.sm-menu').addClass('re-rotate');
                      if (settings.closeButton !== false) {
                        el.prepend(
                          "<a href='#' class='sm-close'>" +
                            settings.closeButton +
                            '</a>'
                        );

                        $('.sm-close').click(function () {
                          el.closeMenu();
                          return false;
                        });
                      }

                      $('.sm-menu .sm-nav:first-child .nav-inner').addClass(
                        'animated flyInLeft'
                      );
                      $('.sm-menu .sm-nav:nth-child(2) .nav-inner').addClass(
                        'animated flyInRight'
                      );
                      $('.sm-overlay:not(.clicked)')
                        .addClass('clicked')
                        .click(function () {
                          el.closeMenu();
                        });
                    }
                  }
                );
              }
            }
          );
        });
      } else {
        el.closeMenu();
      }
    };

    if (settings.button !== false) {
      $(
        "<a href='#' class='sm-button'>" + settings.button + '</a>'
      ).insertAfter(el);
    }

    $('.sm-button').click(function () {
      el.openMenu();
      return false;
    });
  };
})(window.jQuery);

$('.sidemenu').square_menu({
  flyDirection: 'bottom', // The direction where the menu will fly from. Available options are "top", "bottom", "left", "right", "top-left", "top-right", "bottom-left" and "bottom-right". The default value is "bottom".
  button: false, // You can define text inside the auto-generated button here. If you want to prevent the plugin from generating a menu button, change this to false. The default value is "Menu".
  animationStyle: 'vertical', // The type of animation style you will see after it flew in. Available options are "vertical" which expands vertically and "horizontal" which expands horizontally. Vertical works best with "top" or "bottom" flyDirection whereas Horizontal works best with "left" or "right" flyDirection. The default value is "vertical".
  closeButton: false, // You can define the content of the close button appears after animates are completed here. Change this to false to hide the close button. The default value is X.
});

$('.header-nav-btn' || '.contact-btn').click(function () {
  $('.sidemenu').openMenu();
});

$('.close-btn').click(function () {
  $('.sidemenu').closeMenu();
});

/*global jQuery */
/*jshint browser:true */
/*!
 * FitVids 1.1
 *
 * Copyright 2013, Chris Coyier - http://css-tricks.com + Dave Rupert - http://daverupert.com
 * Credit to Thierry Koblentz - http://www.alistapart.com/articles/creating-intrinsic-ratios-for-video/
 * Released under the WTFPL license - http://sam.zoy.org/wtfpl/
 *
 */

(function ($) {
  'use strict';

  $.fn.fitVids = function (options) {
    var settings = {
      customSelector: null,
      ignore: null,
    };

    if (!document.getElementById('fit-vids-style')) {
      // appendStyles: https://github.com/toddmotto/fluidvids/blob/master/dist/fluidvids.js
      var head = document.head || document.getElementsByTagName('head')[0];
      var css =
        '.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}';
      var div = document.createElement('div');
      div.innerHTML = '<p>x</p><style id="fit-vids-style">' + css + '</style>';
      head.appendChild(div.childNodes[1]);
    }

    if (options) {
      $.extend(settings, options);
    }

    return this.each(function () {
      var selectors = [
        "iframe[src*='player.vimeo.com']",
        "iframe[src*='youtube.com']",
        "iframe[src*='youtube-nocookie.com']",
        "iframe[src*='kickstarter.com'][src*='video.html']",
        'object',
        'embed',
      ];

      if (settings.customSelector) {
        selectors.push(settings.customSelector);
      }

      var ignoreList = '.fitvidsignore';

      if (settings.ignore) {
        ignoreList = ignoreList + ', ' + settings.ignore;
      }

      var $allVideos = $(this).find(selectors.join(','));
      $allVideos = $allVideos.not('object object'); // SwfObj conflict patch
      $allVideos = $allVideos.not(ignoreList); // Disable FitVids on this video.

      $allVideos.each(function () {
        var $this = $(this);
        if ($this.parents(ignoreList).length > 0) {
          return; // Disable FitVids on this video.
        }
        if (
          (this.tagName.toLowerCase() === 'embed' &&
            $this.parent('object').length) ||
          $this.parent('.fluid-width-video-wrapper').length
        ) {
          return;
        }
        if (
          !$this.css('height') &&
          !$this.css('width') &&
          (isNaN($this.attr('height')) || isNaN($this.attr('width')))
        ) {
          $this.attr('height', 9);
          $this.attr('width', 16);
        }
        var height =
            this.tagName.toLowerCase() === 'object' ||
            ($this.attr('height') && !isNaN(parseInt($this.attr('height'), 10)))
              ? parseInt($this.attr('height'), 10)
              : $this.height(),
          width = !isNaN(parseInt($this.attr('width'), 10))
            ? parseInt($this.attr('width'), 10)
            : $this.width(),
          aspectRatio = height / width;
        if (!$this.attr('id')) {
          var videoID = 'fitvid' + Math.floor(Math.random() * 999999);
          $this.attr('id', videoID);
        }
        $this
          .wrap('<div class="fluid-width-video-wrapper"></div>')
          .parent('.fluid-width-video-wrapper')
          .css('padding-top', aspectRatio * 100 + '%');
        $this.removeAttr('height').removeAttr('width');
      });
    });
  };
  // Works with either jQuery or Zepto
})(window.jQuery || window.Zepto);

$(document).ready(function () {
  $('.diptic').fitVids();
});

function checkStock() {
  //$('input[name="id"]')
  var stock = $('#product-select').data('stock');
  if (typeof stock == 'undefined') {
    stock = $('#product-select').find(':selected').data('stock');
  }

  if (stock == 0) {
    setOutofStock(true);
  } else {
    setOutofStock(false);
  }
}

function setOutofStock(isOutOfStock) {
  if (isOutOfStock == true) {
    $('#outofstock').removeClass('hidden');
    $('#addtocart').addClass('hidden');
    $('#addtocart').css('display', 'none');
  } else {
    $('#outofstock').addClass('hidden');
    $('#addtocart').removeClass('hidden');
    $('#addtocart').css('display', 'block');
  }
}

// wrap fades in when in viewport
(function ($) {
  $.fn.getPercentVisible = function () {
    var $object = this,
      $w = $(window),
      top = $w.scrollTop(),
      bottom = $w.height() + top,
      slideTop = $object.offset().top,
      slideHeight = $object.height(),
      slideBottom = slideTop + slideHeight;

    if (slideBottom > top && slideTop < bottom) {
      var percentVisible =
        top > slideTop ? slideBottom - top : bottom - slideTop;
      return percentVisible / slideHeight;
    }

    return 0;
  };
  $.fn.visible = function (partial) {
    try {
      var visible = this.getPercentVisible();
      if (partial === true && visible > 0.3) {
        return true;
      } else if (visible > 0.8) {
        return true;
      }
      return false;
    } catch (err) {
      return false;
    }
  };
})(jQuery);

/* ===========================================================
 *
 *  Name:          selectordie.js
 *  Updated:       2014-04-28
 *  Version:       0.1.3
 *  Created by:    Per V @ Vst.mn
 *  What?:         The Select or Die JS
 *
 *  Copyright (c) 2014 Per Vestman
 *  Dual licensed under the MIT and GPL licenses.
 *
 *  To much comments in the code. Please, I know.
 *
 *  Beards, Rock & Loud Guns | Cogs 'n Kegs
 *
 * =========================================================== */

(function ($) {
  $.fn.selectOrDie = function (method) {
    'use strict';

    var $defaults = {
        customID: null, // String - "" by default - Adds an ID to the SoD
        customClass: '', // String - "" by default - Adds a class to the SoD
        placeholder: null, // String - "" by default - Adds a placeholder that will be shown before a selection has been made
        prefix: null, // String - "" by default - Adds a prefix that always will be shown before the selected value
        cycle: false, // Boolean - false by default - Should keyboard cycle through options or not?
        links: false, // Boolean - false by default - Should the options be treated as links?
        linksExternal: false, // Boolean - false by default - Should the options be treated as links and open in a new window/tab?
        size: 0, // Integer - 0 by default - The value set equals the amount of items before scroll is needed
        tabIndex: 0, // integer - 0 by default
        onChange: $.noop, // Adds a callback function for when the SoD gets changed
      },
      $_settings = {},
      $_sodFilterTimeout,
      $_sodViewportTimeout;

    var _private = {
      initSoD: function (options) {
        $_settings = $.extend({}, $defaults, options);

        return this.each(function (i) {
          if (!$(this).parent().hasClass('sod_select')) {
            var $select = $(this),
              $settingsId = $_settings.customID
                ? $_settings.customID
                : $select.data('custom-id')
                ? $select.data('custom-id')
                : $_settings.customID,
              $settingsClass = $_settings.customClass
                ? $_settings.customClass
                : $select.data('custom-class')
                ? $select.data('custom-class')
                : $_settings.customClass,
              $settingsPrefix = $_settings.prefix
                ? $_settings.prefix
                : $select.data('prefix')
                ? $select.data('prefix')
                : $_settings.prefix,
              $settingsPlaceholder = $_settings.placeholder
                ? $_settings.placeholder
                : $select.data('placeholder')
                ? $select.data('placeholder')
                : $_settings.placeholder,
              $settingsCycle =
                $_settings.cycle || $select.data('cycle')
                  ? true
                  : $_settings.cycle,
              $settingsLinks =
                $_settings.links || $select.data('links')
                  ? true
                  : $_settings.links,
              $settingsLinksExternal =
                $_settings.linksExternal || $select.data('links-external')
                  ? true
                  : $_settings.linksExternal,
              $settingsSize = $_settings.size
                ? $_settings.size
                : $select.data('size')
                ? $select.data('size')
                : $_settings.size,
              $settingsTabIndex = $_settings.tabIndex
                ? $_settings.tabIndex
                : $select.data('tabindex')
                ? $select.data('tabindex')
                : $select.attr('tabindex')
                ? $select.attr('tabindex')
                : $_settings.tabIndex,
              $selectTitle = $select.prop('title')
                ? $select.prop('title')
                : null,
              $selectDisabled = $select.is(':disabled') ? ' disabled' : '',
              $sodPrefix = '',
              $sodHtml = '',
              $sodHeight = 0,
              $sod,
              $sodListWrapper,
              $sodList;

            // If there's a prefix defined
            if ($settingsPrefix) {
              $sodPrefix =
                '<span class="sod_prefix">' + $settingsPrefix + '</span> ';
            }

            // If there's a placeholder defined
            if ($settingsPlaceholder && !$settingsPrefix) {
              $sodHtml +=
                '<div class="sod_label sod_placeholder">' +
                $settingsPlaceholder +
                '</span>';
            } else {
              $sodHtml += '<div class="sod_label">' + $sodPrefix + '</div>';
            }

            // Inserts a new element that will act like our new <select>
            $sod = $('<div/>', {
              id: $settingsId,
              class: 'sod_select ' + $settingsClass + $selectDisabled,
              title: $selectTitle,
              tabindex: $settingsTabIndex,
              html: $sodHtml,
              'data-cycle': $settingsCycle,
              'data-links': $settingsLinks,
              'data-links-external': $settingsLinksExternal,
              'data-placeholder': $settingsPlaceholder,
              'data-prefix': $settingsPrefix,
              'data-filter': '',
            }).insertAfter(this);

            // If it's a touch device
            if (_private.isTouch()) {
              $sod.addClass('touch');
            }

            // Add a wrapper for the option list
            $sodListWrapper = $('<div/>', {
              class: 'sod_list',
            }).appendTo($sod);

            // Inserts a <ul> into our wrapper created above. It will host our <option>:s
            $sodList = $('<ul/>').appendTo($sodListWrapper);

            // Inserts a <li> for each <option>
            $('option, optgroup', $select).each(function (i) {
              _private.populateSoD($(this), $sodList, $sod);
            });

            // If the setting size is set, then add a max-height to the SoD
            if ($settingsSize) {
              // Show the SoD options
              $sodListWrapper.show();

              // Calculate a max-height
              $('li:lt(' + $settingsSize + ')', $sodList).each(function (i) {
                $sodHeight += $(this).outerHeight();
              });

              // Hide the SoD list wrapper and set a "max-height" to the list itself
              $sodListWrapper.removeAttr('style');
              $sodList.css({ 'max-height': $sodHeight });
            }

            // Move the <select> into the SoD element
            $select.appendTo($sod);

            // Bind events to the SoD
            $sod
              .on('focusin', _private.focusSod)
              .on('click', _private.triggerSod)
              .on('click', 'li', _private.optionClick)
              .on('mousemove', 'li', _private.optionHover)
              .on('keydown keypress', _private.keyboardUse);

            // Bind change event to the <select>
            $select.on('change', _private.selectChange);

            // Blur the SoD when clicking outside it
            $('html').on('click', function () {
              _private.blurSod($sod);
            });

            // When a label for the native select is clicked we want to focus the SoD
            $(document).on(
              'click',
              "label[for='" + $select.attr('id') + "']",
              function (e) {
                e.preventDefault();
                $sod.focus();
              }
            );
          } else {
            console.log('Select or Die: It looks like the SoD already exists');
          }
        });
      }, // initSoD

      populateSoD: function ($option, $sodList, $sod) {
        var $sodPlaceholder = $sod.data('placeholder'),
          $sodPrefix = $sod.data('prefix'),
          $optionParent = $option.parent(),
          $optionText = $option.text(),
          $optionValue = $option.val(),
          $optionCustomId = $option.data('custom-id')
            ? $option.data('custom-id')
            : null,
          $optionCustomClass = $option.data('custom-class')
            ? $option.data('custom-class')
            : '',
          $optionIsDisabled = $option.is(':disabled') ? ' disabled ' : '',
          $optionIsSelected = $option.is(':selected')
            ? ' selected active '
            : '',
          $optionLink = $option.data('link') ? ' link ' : '',
          $optionLinkExternal = $option.data('link-external')
            ? ' linkexternal'
            : '';

        // Create <li> for each <option>
        if ($option.is('option')) {
          // If <option>
          $('<li/>', {
            class:
              $optionCustomClass +
              $optionIsDisabled +
              $optionIsSelected +
              $optionLink +
              $optionLinkExternal,
            id: $optionCustomId,
            title: $optionText,
            html: $optionText,
            'data-value': $optionValue,
          }).appendTo($sodList);

          // If selected and no placeholder is set, update label
          if (
            ($optionIsSelected && !$sodPlaceholder) ||
            ($optionIsSelected && $sodPrefix)
          ) {
            $sod.find('.sod_label').append($optionText);
          }

          // Set the SoD data-label (used in the blur event)
          if ($optionIsSelected && $sodPlaceholder && !$sodPrefix) {
            $sod.data('label', $sodPlaceholder);
          } else if ($optionIsSelected) {
            $sod.data('label', $optionText);
          }

          // If child of an <optgroup>
          if ($optionParent.is('optgroup')) {
            $sodList.find('li:last').addClass('groupchild');

            // If <optgroup> disabled
            if ($optionParent.is(':disabled')) {
              $sodList.find('li:last').addClass('disabled');
            }
          }
        } else {
          // If <<optgroup>
          $('<li/>', {
            class: 'optgroup ' + $optionIsDisabled,
            title: $option.prop('label'),
            html: $option.prop('label'),
            'data-label': $option.prop('label'),
          }).appendTo($sodList);
        }
      }, // populateSoD

      focusSod: function () {
        var $sod = $(this);

        // If not disabled we'll add focus and an .active class to enable keyboard
        if (!$sod.hasClass('disabled')) {
          $sod.addClass('focus');
        } else {
          _private.blurSod($sod);
        }
      }, // focusSod

      triggerSod: function (e) {
        e.stopPropagation();

        var $sod = $(this),
          $sodList = $sod.find('ul'),
          $sodPlaceholder = $sod.data('placeholder'),
          $optionSelected = $sod.find('.selected');

        // Trigger the SoD if it's not disabled, already open or a touch device
        if (
          !$sod.hasClass('disabled') &&
          !$sod.hasClass('open') &&
          !$sod.hasClass('touch')
        ) {
          // Add the .open class to display list
          $sod.addClass('open');

          // Close all other SoD's except for the current one
          $('.sod_select').not(this).removeClass('open focus');

          // If a placeholder is set, then show it
          if ($sodPlaceholder && !$sod.data('prefix')) {
            $sod
              .find('.sod_label')
              .addClass('sod_placeholder')
              .html($sodPlaceholder);
          }

          // Scroll list to selected item
          _private.listScroll($sodList, $optionSelected);

          // Check if the option list fits in the viewport
          _private.checkViewport($sod, $sodList);
        } else {
          // Clears viewport check timeout
          clearTimeout($_sodViewportTimeout);
          $sod.removeClass('open above');
        }
      }, // triggerSod

      keyboardUse: function (e) {
        var $sod = $(this),
          $sodList = $sod.find('ul'),
          $sodOptions = $sod.find('li'),
          $sodLabel = $sod.find('.sod_label'),
          $sodCycle = $sod.data('cycle'),
          $optionActive = $sodOptions.filter('.active'),
          $sodFilterHit,
          $optionNext,
          $optionCycle,
          $scrollList,
          $scrollOption;

        // "Filter" options list using keybaord based input
        if (e.which !== 0 && e.charCode !== 0) {
          // Clears data-filter timeout
          clearTimeout($_sodFilterTimeout);

          // Append the data-filter with typed character
          $sod.data(
            'filter',
            $sod.data('filter') + String.fromCharCode(e.keyCode | e.charCode)
          );

          // Check for matches of the typed string
          $sodFilterHit = $sodOptions
            .filter(function () {
              return (
                $(this)
                  .text()
                  .toLowerCase()
                  .indexOf($sod.data('filter').toLowerCase()) === 0
              );
            })
            .not('.disabled, .optgroup')
            .first();

          // If the typed value is a hit, then set it to active
          if ($sodFilterHit.length) {
            $optionActive.removeClass('active');
            $sodFilterHit.addClass('active');
            _private.listScroll($sodList, $sodFilterHit);
            $sodLabel.get(0).lastChild.nodeValue = $sodFilterHit.text();
          }

          // Set a timeout to empty the data-filter
          $_sodFilterTimeout = setTimeout(function () {
            $sod.data('filter', '');
          }, 500);
        }

        // Highlight prev/next element if up/down key pressed
        if (e.which > 36 && e.which < 41) {
          // Set $optionNext and $optionCycle
          if (e.which === 37 || e.which === 38) {
            // Left/Up key
            $optionNext = $optionActive
              .prevAll(":not('.disabled, .optgroup')")
              .first();
            $optionCycle = $sodOptions.not('.disabled, .optgroup').last();
          } else if (e.which === 39 || e.which === 40) {
            // Right/Down key
            $optionNext = $optionActive
              .nextAll(":not('.disabled, .optgroup')")
              .first();
            $optionCycle = $sodOptions.not('.disabled, .optgroup').first();
          }

          // If there's no option before/after and cycle is enabled
          if (!$optionNext.is('li') && $sodCycle) {
            $optionNext = $optionCycle;
          }

          // Add .active to the next option, update the label and scroll the list
          if ($optionNext.is('li') || $sodCycle) {
            $optionActive.removeClass('active');
            $optionNext.addClass('active');
            $sodLabel.get(0).lastChild.nodeValue = $optionNext.text();
            _private.listScroll($sodList, $optionNext);
          }

          // Disables the up/down keys from scrolling the page
          return false;
        } else if (
          e.which === 13 ||
          (e.which === 32 &&
            $sod.hasClass('open') &&
            $sod.data('filter') === '')
        ) {
          // Enter key or space, simulate click() function
          e.preventDefault();
          $optionActive.click();
        } else if (
          e.which === 32 &&
          !$sod.hasClass('open') &&
          $sod.data('filter') === ''
        ) {
          // Space bar, Opens the SoD if already closed
          e.preventDefault();
          $sod.click();
        } else if (e.which === 27) {
          // Esc key, hides dropdown
          _private.blurSod($sod);
        }
      }, // keyboardUse

      optionHover: function () {
        var $option = $(this);

        // Mousemove event on option to make the SoD behave just like a native select
        if (!$option.hasClass('disabled') && !$option.hasClass('optgroup')) {
          $option.siblings().removeClass('active').end().addClass('active');
        }
      }, // optionHover

      optionClick: function (e) {
        e.stopPropagation();

        var $clicked = $(this),
          $sod = $clicked.closest('.sod_select'),
          $optionDisabled = $clicked.hasClass('disabled'),
          $optionOptgroup = $clicked.hasClass('optgroup'),
          $optionIndex = $sod.find("li:not('.optgroup')").index(this);

        // If not disabled or optgroup
        if (!$optionDisabled && !$optionOptgroup) {
          $sod
            .find('.selected, .sod_placeholder')
            .removeClass('selected sod_placeholder');
          $clicked.addClass('selected');
          $sod.find('select option')[$optionIndex].selected = true;
          $sod.find('select').change();
        }

        // Clear viewport check timeout
        clearTimeout($_sodViewportTimeout);

        // Hide the list
        $sod.removeClass('open above');
      }, // optionClick

      selectChange: function () {
        var $select = $(this),
          $optionSelected = $select.find(':selected'),
          $optionText = $optionSelected.text(),
          $sod = $select.closest('.sod_select');

        $sod.find('.sod_label').get(0).lastChild.nodeValue = $optionText;
        $sod.data('label', $optionText);

        // Triggers the onChange callback
        $_settings.onChange.call(this);

        // If $_settings.links, send the user to the URL
        if (
          ($sod.data('links') || $optionSelected.data('link')) &&
          !$optionSelected.data('link-external')
        ) {
          window.location.href = $optionSelected.val();
        } else if (
          $sod.data('links-external') ||
          $optionSelected.data('link-external')
        ) {
          window.open($optionSelected.val(), '_blank');
        }
      }, // selectChange

      blurSod: function ($sod) {
        if ($('body').find($sod).length) {
          var $sodLabel = $sod.data('label'),
            $optionActive = $sod.find('.active'),
            $optionSelected = $sod.find('.selected');

          // Clear viewport check timeout
          clearTimeout($_sodViewportTimeout);

          // Remove above/open class
          $sod.removeClass('open focus above');

          // Restore the select if no change has been made
          if (!$optionActive.hasClass('selected')) {
            $sod.find('.sod_label').get(0).lastChild.nodeValue = $sodLabel;
            $optionActive.removeClass('active');
            $optionSelected.addClass('active');
          }

          $sod.blur();
        }
      }, // blurSod

      checkViewport: function ($sod, $sodList) {
        var $sodPosition = $sod[0].getBoundingClientRect(),
          $sodListHeight = $sodList.outerHeight();

        // If the list is below the viewport AND fits above, then show it above
        if (
          $sodPosition.bottom + $sodListHeight + 10 > $(window).height() &&
          $sodPosition.top - $sodListHeight > 10
        ) {
          $sod.addClass('above');
        } else {
          $sod.removeClass('above');
        }

        // This was fun, lets do it again and again.
        $_sodViewportTimeout = setTimeout(function () {
          _private.checkViewport($sod, $sodList);
        }, 200);
      }, // checkViewport

      listScroll: function ($sodList, $option) {
        var $scrollList = $sodList[0].getBoundingClientRect(), // getBoundingClientRect FTW!
          $scrollOption = $option[0].getBoundingClientRect();

        // Scroll list up and down
        if ($scrollList.top > $scrollOption.top) {
          $sodList.scrollTop(
            $sodList.scrollTop() - $scrollList.top + $scrollOption.top
          );
        } else if ($scrollList.bottom < $scrollOption.bottom) {
          $sodList.scrollTop(
            $sodList.scrollTop() - $scrollList.bottom + $scrollOption.bottom
          );
        }
      }, // listScroll

      isTouch: function () {
        return (
          'ontouchstart' in window ||
          navigator.MaxTouchPoints > 0 ||
          navigator.msMaxTouchPoints > 0
        );
      }, // isTouch
    };

    var methods = {
      destroy: function () {
        return this.each(function (i) {
          var $select = $(this),
            $sod = $select.parent();

          // Destroy the SoD
          if ($sod.hasClass('sod_select')) {
            // Unbind the change event on the real <select>
            $select.off('change');

            // Restore DOM
            $sod.find('div').remove();
            $select.unwrap();
          } else {
            console.log("Select or Die: There's no SoD to destroy");
          }
        });
      }, // destroy

      update: function () {
        return this.each(function (i) {
          var $select = $(this),
            $sod = $select.parent(),
            $sodList = $sod.find('ul:first');

          // Check for the SoD
          if ($sod.hasClass('sod_select')) {
            // Empty current list of options in faux <select>
            $sodList.empty();

            // Clear the label (but keep prefix)
            $sod.find('.sod_label').get(0).lastChild.nodeValue = '';

            // Disable the SoD if the select is disabled
            if ($select.is(':disabled')) {
              $sod.addClass('disabled');
            }

            // Inserts a <li> for each <option>
            $('option, optgroup', $select).each(function (i) {
              _private.populateSoD($(this), $sodList, $sod);
            });
          } else {
            console.log("Select or Die: There's no SoD to update");
          }
        });
      }, // update

      disable: function ($value) {
        return this.each(function (i) {
          var $select = $(this),
            $sod = $select.parent();

          // Check for the SoD
          if ($sod.hasClass('sod_select')) {
            if (typeof $value !== 'undefined') {
              // Disable option/optgroup

              // Disables the option (and possible children if optgroup) in the SoD
              $sod
                .find("ul:first li[data-value='" + $value + "']")
                .addClass('disabled');
              $sod
                .find("ul:first li[data-label='" + $value + "']")
                .nextUntil(':not(.groupchild)')
                .addClass('disabled');

              // Disables the option/optgroup in the real <select>
              $(
                "option[value='" +
                  $value +
                  "'], optgroup[label='" +
                  $value +
                  "']",
                this
              ).prop('disabled', true);
            } else if ($sod.hasClass('sod_select')) {
              // Disable select/SoD
              $sod.addClass('disabled');
              $select.prop('disabled', true);
            }
          } else {
            console.log("Select or Die: There's no SoD to disable");
          }
        });
      }, // disable

      enable: function ($value) {
        return this.each(function (i) {
          var $select = $(this),
            $sod = $select.parent();

          // Check for the SoD
          if ($sod.hasClass('sod_select')) {
            if (typeof $value !== 'undefined') {
              // Enable option/optgroup

              // Enables the option (and possible children if optgroup) in the SoD
              $sod
                .find("ul:first li[data-value='" + $value + "']")
                .removeClass('disabled');
              $sod
                .find("ul:first li[data-label='" + $value + "']")
                .nextUntil(':not(.groupchild)')
                .removeClass('disabled');

              // Enables the option in the real <select>
              $(
                "option[value='" +
                  $value +
                  "'], optgroup[label='" +
                  $value +
                  "']",
                this
              ).prop('disabled', false);
            } else if ($sod.hasClass('sod_select')) {
              // Enable select/SoD
              $sod.removeClass('disabled');
              $select.prop('disabled', false);
            }
          } else {
            console.log("Select or Die: There's no SoD to enable");
          }
        });
      }, // enable
    };

    if (methods[method]) {
      return methods[method].apply(
        this,
        Array.prototype.slice.call(arguments, 1)
      );
    } else if (typeof method === 'object' || !method) {
      return _private.initSoD.apply(this, arguments);
    } else {
      $.error(
        'Select or Die: Oh no! No such method "' +
          method +
          '" for the SoD instance'
      );
    }
  };
})(jQuery);

$('.filter-brand__select').selectOrDie({
  //placeholder: "Filter by Brand",
  onChange: function () {
    var val = $(this).find(':selected').val();

    if (!$(this).hasClass('brand_search')) {
      if (val == 'all') {
        location.href = '/collections/all';
      } else {
        location.href = '/collections/vendors?q=' + val;
      }
    }
  },
});

$('select').not('.filter-brand').selectOrDie();

(function ($) {
  $(document).ready(function () {
    var $filterDropdown = $('.filter_options');

    // Filter Drawer Handler
    $('.filter_title_group').each(function (index, value) {
      var filterTrigger = '.filter_toggle, .filter_toolbar-title h2',
        $this = $(this);

      $(filterTrigger, $this).click(function () {
        var $thisFilterDropdown = $filterDropdown.eq(index);
        var $thisFilterTrigger = $(filterTrigger, $this);

        //close all open filters other than the current
        $filterDropdown.not($thisFilterDropdown).removeClass('is-open');
        $(filterTrigger).not($thisFilterTrigger).removeClass('is-open');

        //toggle the current
        $thisFilterDropdown.toggleClass('is-open');
        $thisFilterTrigger.toggleClass('is-open');
      });
    });

    //category handler
    var catTrigger = '.filter_cat-title',
      catDropdown = '.filter_cat-list';

    // click trigger, toggle it's dropdown
    $(catTrigger).click(function () {
      $(this).siblings(catDropdown).toggleClass('is-open');
    });
  });
})(jQuery);

$(document).ready(function () {
  var catTrigger = '.filter_cat-title',
    catDropdown = '.filter_cat-list';
  filterSelectedItem = '.filter_selected-filters';

  // click trigger, toggle it's dropdown
  $(catTrigger).click(function () {
    var menuExpand = $(this).attr('data-menu');
    $(this).siblings(catDropdown).toggleClass('is-open');
    $('#' + menuExpand).toggleClass('is-open');
    //$(catTrigger).siblings(catDropdown).toggleClass('is-open');
  });

  $(filterSelectedItem).on('click', function (event) {
    const collection = $(event.target).data('collection');
    const tag = $(event.target).data('tag');

    const urlToReplace = new URL(window.location.href);

    if (collection) {
      if (collection === 'all') return;
      urlToReplace.pathname = urlToReplace.pathname.replace(collection, 'all');
    }

    if (tag) {
      urlToReplace.pathname = urlToReplace.pathname.replace(tag, '');
      urlToReplace.pathname = urlToReplace.pathname.replace(',,', ',');
    }

    if (urlToReplace.pathname.endsWith('collections/')) {
      urlToReplace.pathname = urlToReplace.pathname.replace(
        'collections/',
        'collections/all'
      );
    }

    window.location.href = urlToReplace.href;
  });
});

/* Pagination
   ========================================================================== */

$(document).ready(function () {
  if ($('.pagination').length) {
    var $current = $('.pagination .current');
    $deco = $('.pagination .deco');

    /* Replace '...' with '—' */
    $deco.text('—');

    /* If element is longer than 1 character, add class for styling */
    if ($current.text().length > 1) {
      $current.addClass('long');
    }
  }
});

$(document).ready(function () {
  /**
   * Search Bar in Primary Nav
   */
  var search = ".nav_search input[type='search']",
    submit = ".nav_search input[type='submit']";

  $(search)
    .focus(function () {
      // expand the search input
      $(this).addClass('is-open');
      // make submit button pressable
      $(submit).addClass('is-pressable');
      // remove the submit's disabled property
      $(submit).prop('disabled', false);
    })
    .blur(function () {
      // if search has a value
      if ($(search).val()) {
      }
      // if search is empty
      else {
        // reset to default state
        $(this).removeClass('is-open');
        $(submit).removeClass('is-pressable');
        $(submit).prop('disabled', true);
      }
    });
});

/* Toolbar expander
   ========================================================================== */

(function () {
  var $toggleTrigger = $('.toggle__trigger'),
    $toggleBody = $('.toggle__body');

  $toggleTrigger.click(function () {
    $toggleBody.toggleClass('is-expanded');

    $('.m_toolbar-filter').toggleClass('is-expanded');
  });
})();

/* NEW MENU FROM DPL 
   ===========================================================================*/
var onscreenSelector = '.diptic,.diptic-col-wrap,.m_tile';

(function ($) {
  function scrollToObject(object) {
    $('html,body').animate(
      {
        scrollTop: object.offset().top,
      },
      1000
    );
  }

  $(document).ready(function () {
    var sidebarNav = {}; // Sidebar navigation

    //show/hide
    sidebarNav.showHide = function (trigger, sidebarEl, shiftedEl) {
      $('.l-doc-wrap').on('click', trigger, function (e) {
        e.preventDefault();

        // disable scroll
        $('body').toggleClass('stop-scroll');
        // toggle sidebar visibility
        $(sidebarEl).toggleClass('is-showing');
        // toggle shifted element
        $(shiftedEl).toggleClass('is-shifted');
        // toggle brand name (shown in sidebar)
        $('.header_logo-type').toggleClass('is-hidden');
        // toggle top level nav items
        $('.header_site-nav').toggleClass('is-hidden');
        // toggle the openers visibility (close toggle is in sidebar)
        $('._open-sidebar_icon').toggleClass('is-hidden');

        return false;
      });

      $(sidebarEl).hover(
        function () {
          //$(this).addClass('focussed');
        },
        function () {
          $(this).removeClass('');
          // disable scroll
          $('body').removeClass('stop-scroll');
          // toggle sidebar visibility
          $(sidebarEl).removeClass('is-showing');
          // toggle shifted element
          $(shiftedEl).removeClass('is-shifted');
          // toggle brand name (shown in sidebar)
          $('.header_logo-type').removeClass('is-hidden');
          // toggle brand name (shown in sidebar)
          $('.header_site-nav').removeClass('is-hidden');
          // toggle the openers visibility (close toggle is in sidebar)
          $('._open-sidebar_icon').removeClass('is-hidden');
        }
      );
    };
    sidebarNav.showHide(
      '#js_open-sidebar, #js_close-sidebar, .l-main-wrap.is-shifted',
      '.l-sidebar-wrap',
      '.l-main-wrap'
    );

    // disable hover effects on scroll for smoother scrolling
    (function () {
      var body = document.body,
        timer;

      window.addEventListener(
        'scroll',
        function () {
          clearTimeout(timer);
          if (!body.classList.contains('disable-hover')) {
            body.classList.add('disable-hover');
          }

          timer = setTimeout(function () {
            body.classList.remove('disable-hover');
          }, 200);
        },
        false
      );
    })();

    // ensure that both dropdown lists can't be opened at the same time
    sidebarNav.expandableLists = function () {
      var sidebarBrands = '.sidebar-nav__brands ul',
        sidebarStyles = '.sidebar-nav__styles ul',
        sidebarListTrigger = '.nav_dropdown-trigger';

      $(sidebarListTrigger).click(function () {
        if (!$(this).siblings('ul').hasClass('is-open')) {
          // close all the shii
          $(sidebarBrands + ', ' + sidebarStyles).removeClass('is-open');
          // open the relevant one
          $(this).siblings('ul').addClass('is-open');
        } else {
          // if list is already open, use the trigger to close the list
          $(this).siblings('ul').removeClass('is-open');
        }
      });
    };
    sidebarNav.expandableLists();

    //Search Overlay
    var searchOverlay = {};

    searchOverlay.visibility = function (visibility) {
      // cache elements
      var trigger = '#search-open',
        overlayEl = '.l-search';

      if (visibility === 'show') {
        // show overlay
        $(overlayEl).addClass('is-visible');
        // disable scroll
        $('body').addClass('stop-scroll');
        // focus the element
        $('#search-overlay_input').focus();
        // show helper
        $('.-search-helper').addClass('is-visible');
      } else {
        // hide overlay
        $(overlayEl).removeClass('is-visible');
        // enable scroll
        $('body').removeClass('stop-scroll');
        // clear search form
        $('search-overlay_input').val('');
        // hide helper
        $('.-search-helper').removeClass('is-visible');
      }
    };

    searchOverlay.formHelpers = function () {
      $('#search-overlay_input').on('keyup', function () {
        if ($(this).val() === '') {
          //$('.-search-helper p').html("What can we help you find?");
          $(this).closest('.search-overlay_form').removeClass('has-value');
        } else {
          //$('.-search-helper p').html("Press enter when you're ready");
          $(this).closest('.search-overlay_form').addClass('has-value');
        }
      });
    };

    searchOverlay.showHide = function (showTrigger, hideTrigger) {
      $(showTrigger).on('click', function (e) {
        searchOverlay.visibility('show');
      });

      $(hideTrigger).on('click', function (e) {
        searchOverlay.visibility('hidden');
      });
    };

    searchOverlay.visibility();
    searchOverlay.formHelpers();
    searchOverlay.showHide(
      '#search-open',
      '.header_open-sidebar.-close button'
    );
    //cart = new shopify_cart();

    //handle data-link scroll to
    $('a[data-link],button[data-link]').click(function () {
      var link_class = $(this).data('link');
      var scrollObject = $(link_class);
      scrollToObject(scrollObject);
      return false;
    });
  });
})(jQuery);

(function ($) {
  var mCollectionScroller = function (objectToBindTo) {
    var _ = this;
    this.padding = 120;
    this.$object = $(objectToBindTo);
    this.elementSelector = '.m_collection-list,.shop-gallery';
    this.timerrs;

    this.addIndicator = function ($element) {
      var output = "<aside class='scrollIndicator right'><div></div></aside>";
      output += "<aside class='scrollIndicator left'><div></div></aside>";
      $element.append(output);
      $element.addClass('hasScrollIndicator');
    };

    this.setupScrollers = function () {
      $(_.elementSelector)
        .not('.sInit')
        .each(function () {
          var $this = this;
          this.$list = $(this);
          this.$parent = this.$list.parent();
          this.scrollTimer;
          this.resizeTimer;
          this.width;
          this.scrollWidth;
          this.containerWidth;
          _.addIndicator(this.$parent);
          this.indicator = $('.scrollIndicator.right', this.$parent);
          this.indicatorLeft = $('.scrollIndicator.left', this.$parent);

          this.$list.addClass('sInit');

          this.setWidth = function () {
            $this.containerWidth = $this.$list.get(0).clientWidth;
            $this.scrollWidth = $this.$list.get(0).scrollWidth;
            $this.width = $this.scrollWidth - $this.containerWidth;
          };

          this.handleScroll = function () {
            if ($this.containerWidth >= $this.scrollWidth) {
              $this.indicator.removeClass('visible');
              $this.indicatorLeft.removeClass('visible');
              return;
            }

            var left = $this.$list.get(0).scrollLeft;
            if ($this.width - left <= _.padding) {
              $this.indicator.removeClass('visible');
              $this.indicatorLeft.addClass('visible');
            } else {
              $this.indicator.addClass('visible');
              $this.indicatorLeft.removeClass('visible');
            }
          };
          this.debounceScroll = function () {
            $this.scrollTimer && clearTimeout($this.scrollTimer);
            $this.scrollTimer = setTimeout($this.handleScroll, 50);
          };
          this.resize = function () {
            $this.resizeTimer && clearTimeout($this.resizeTimer);
            $this.resizeTimer = setTimeout(function () {
              $this.setWidth();
              $this.handleScroll();
            }, 15);
          };

          this.sRight = function () {
            var pos = $this.$list.get(0).scrollLeft;
            var scrollTo = pos + $this.containerWidth;

            if (scrollTo > $this.scrollWidth) {
              scrollTo = $this.scrollWidth;
            }

            $this.$list.animate({ scrollLeft: scrollTo }, 800);
          };

          this.sLeft = function () {
            var pos = $this.$list.get(0).scrollLeft;
            var scrollTo = pos - $this.containerWidth;

            if (scrollTo < 0) {
              scrollTo = 0;
            }

            $this.$list.animate({ scrollLeft: scrollTo }, 800);
          };

          this.setWidth();
          this.handleScroll();

          this.indicatorLeft.on('click', this.sLeft);
          this.indicator.on('click', this.sRight);

          this.$list.on('scroll', $this.debounceScroll);
          $(window).on('resize', $this.resize);
        });
    };

    this.debounceSetupScrollers = function () {
      _.timerrs && clearTimeout(_.timerrs);
      _.timerrs = setTimeout(_.setupScrollers, 70);
    };

    this.init = function () {
      _.$object.bind('DOMSubtreeModified', _.debounceSetupScrollers);
      _.setupScrollers();
    };
    _.init();
  };

  $(document).ready(function () {
    var mcs = new mCollectionScroller('.l-main');
  });
})(jQuery);

/* SEARCH CODE */

(function ($, window, document, undefined) {
  var search_filter = function (opts) {
    var _ = this;

    (this.container = $('#search-filters')),
      (this.filter_categories = $('#filter-categories', _.container)),
      (this.selected_filter_list = $(
        '#search-filter-group .filter_selected-filters ul',
        _.container
      )),
      (this.sortReg = /(&|\?)?sort=([a-z]+)/i),
      (this.directReg = /(&|\?)?direction=([a-z]+)/i),
      (this.sReg = /s=([a-zA-Z\.\%0-9+ ]+)\+?/i),
      (this.specialRoutes = [
        {
          filter: '',
          route: '/collections/all',
        },
        {
          filter: '(tag:new)',
          route: '/collections/new',
        },
        {
          filter: '(tag:his)(tag:sun)',
          route: '/collections/his-sun',
        },
        {
          filter: '(tag:his)(tag:optical)',
          route: '/collections/his-optical',
        },
        {
          filter: '(tag:her)(tag:sun)',
          route: '/collections/her-sun',
        },
        {
          filter: '(tag:her)(tag:optical)',
          route: '/collections/her-optical',
        },
      ]),
      (this.available_tags = [
        {
          name: 'Gender',
          class: 'filter_categories',
          binary: true,
          tags: [
            { name: 'Her Sun', tag: 'her,sun' },
            { name: 'Her Optical', tag: 'her,optical' },
            { name: 'His Sun', tag: 'his,sun' },
            { name: 'His Optical', tag: 'his,optical' },
          ],
        },
        {
          name: 'Category',
          class: 'filter_type',
          tags: [
            { name: 'Accessories', tag: 'accessories', absolute: true },
            { name: 'View All', tag: 'clear', absolute: true },
          ],
        },
        {
          name: 'Brand',
          class: 'filter_brand',
          binary: true,
          tags: blkBrands,
        },
        {
          name: 'Style',
          class: 'filter_collection',
          binary: true,
          tags: [
            { name: 'Active', tag: 'active' },
            { name: 'Aviator', tag: 'aviator' },
            { name: 'Cat Eye', tag: 'cat-eye' },
            { name: 'Classic', tag: 'classic' },
            { name: 'Luxury', tag: 'luxury' },
            { name: 'Minimal', tag: 'minimal' },
            { name: 'Round', tag: 'round' },
            { name: 'Oversized', tag: 'oversized' },
            { name: 'Wayfarer', tag: 'wayfarer' },
          ],
        },
        {
          name: 'Style',
          class: 'filter_style',
          hidden: true,
          tags: [
            { name: 'His', tag: 'his' },
            { name: 'Her', tag: 'her' },
            { name: 'Sun', tag: 'sun' },
            { name: 'Optical', tag: 'optical' },
          ],
        },
      ]),
      (this.selected_tags = []),
      (this.selected_brands = []),
      (this.searchInput = $('.nav_search input[type=search]')),
      (this.search = ''),
      (this.baseSearchURI = '/search?'),
      (this.openFilterOnLoad = 0),
      (this.w = window);

    String.prototype.matchAll = function (regexp) {
      var matches = [];
      this.replace(regexp, function () {
        var arr = [].slice.call(arguments, 0);
        var extras = arr.splice(-2);
        arr.index = extras[0];
        arr.input = extras[1];
        matches.push(arr);
      });
      return matches.length ? matches : null;
    };

    Object.size = function (obj) {
      var size = 0,
        key;
      for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
      }
      return size;
    };

    this.clearAllSelectedTags = function () {
      _.selected_tags = [];
      _.selected_brands = [];
      _.search = '';
    };

    this.arrayUnique = function (array) {
      return array.filter(function (el, index, arr) {
        return index == arr.indexOf(el);
      });
    };

    this.initializeExternalFilters = function () {
      var $external_filters = $('.external_filter');
      $external_filters.each(function () {
        var $category = $(this);
        //build tag cloud
        var tags = [];

        $('a', $category).each(function () {
          var $this = $(this);
          var tag = $this.data('tag');

          if (_.isTagEnabled(tag)) {
            $this.addClass('selected');
          }

          tag = tag.split(',');
          tag.forEach(function (t) {
            tags.push(t);
          });
        });

        //make the tag array unique
        tags = _.arrayUnique(tags);

        $(this).on('click', 'a', function () {
          var $this = $(this);
          var binary = $this.hasClass('binary');

          if (binary) {
            //remove all other selected items
            $('a', $category).not($this).removeClass('selected');
          }

          $this.addClass('selected');

          if (binary) {
            _.binaryToggleSelectedTag(tags, $this.data('tag'));
          } else {
            _.enableSelectedTag($this.data('tag'));
          }

          return false;
        });
      });
    };

    this.checkForSale = function () {
      if (sale_is_enabled) {
        _.available_tags[1].tags.push({
          name: 'Sale',
          tag: 'sale',
          class: 'on-sale',
        });
      }
    };

    this.init = function () {
      _.checkForSale();
      _.parseSelectedTags();
      _.buildTagWidget();
      _.buildSelectedTagWidget();
      _.initializeExternalFilters();

      if (_.openFilterOnLoad == 1) {
        _.openFilterDrawer();
      }

      if (
        Object.size(_.selected_tags) == 0 &&
        Object.size(_.selected_brands) == 0
      ) {
        $('.filter_selected-filters').hide();
        if (_.search == '') {
          $('.filter_clear-all').hide();
        }
      }

      $('.filter_clear-all a').click(function () {
        _.clearAllSelectedTags();
        _.route();
        return false;
      });

      $('.nav_search form').submit(function (event) {
        _.selected_tags = [];
        _.selected_brands = [];
        _.search = _.searchInput.val();
        _.route();

        event.stopPropagation();
        return false;
      });
    };

    this.openFilterDrawer = function () {
      $('.filter_options', _.container).addClass('is-open');
      $('.filter_toggle', _.container).addClass('is-open');
    };

    this.getQueryVariable = function (url, variable) {
      var query = url.slice(url.indexOf('?') + 1);

      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    };

    this.checkSpecialRoute = function (redirectUrl) {
      var s = _.getQueryVariable(redirectUrl, 's');

      var specialRoute = false;
      _.specialRoutes.every(function (special) {
        if (s == special.filter) {
          specialRoute = _.appendSortToURI(special.route);
          return false;
        }
        return true;
      });

      if (specialRoute === false) {
        // Try brand.
        let re = /\/search\?s=\(brand:([\w%\s]+)\)/g;
        var match = redirectUrl.matchAll(re);
        if (match !== null) {
          let brand = match[0][1];
          let route = brand.replaceAll('%20', '-');
          route = route.replaceAll('â€”', '-');
          specialRoute = '/brands/' + route;
        }
      }

      return specialRoute;
    };

    this.route = function () {
      var redirect = _.buildRedirectUrl();
      var specialRedirect = _.checkSpecialRoute(redirect);
      redirect = specialRedirect == false ? redirect : specialRedirect;
      window.location = redirect;
    };

    this.buildRedirectUrl = function () {
      var uri = _.baseSearchURI;

      //add search
      uri += 's=' + _.search;

      //add tags
      for (var tag in _.selected_tags) {
        if (_.selected_tags[tag] != 'search') {
          uri += '(tag:' + tag + ')';
        }
      }

      //add brands
      for (var tag in _.selected_brands) {
        uri += '(brand:' + tag + ')';
      }

      uri = _.appendSortToURI(uri);

      return uri;
    };

    this.appendSortToURI = function (uri) {
      var s = window.location.search;
      s = decodeURIComponent(s);

      var sort_match = s.match(_.sortReg);
      if (sort_match) {
        uri += uri.indexOf('?') == -1 ? '?' : '&';
        uri += 'sort=' + sort_match[2].toLowerCase();
      }

      var direct_match = s.match(_.directReg);
      if (direct_match) {
        uri += uri.indexOf('?') == -1 ? '?' : '&';
        uri += 'direction=' + direct_match[2].toLowerCase();
      }

      return uri;
    };

    this.parseSelectedTags = function () {
      var tags = [];
      var reg = /tag:([a-z\.A-Z0-9\- ]+)/g;
      var brandReg = /brand:([a-z\.A-Z0-9\- ]+)/g;
      var href = decodeURI(_.w.location.href);
      var pathName = new URL(href).pathname;
      var s = _.w.location.href.slice(_.w.location.href.indexOf('?') + 1);
      s = s.replace('%2B', 'PPLUS');
      s = decodeURIComponent(s);

      if (s.indexOf('open=1') != -1) {
        _.openFilterOnLoad = 1;
      }

      var search = s.matchAll(_.sReg);
      if (search) {
        try {
          _.search = search[0][1];
          _.search = _.search.replace('+', ' ');
          _.searchInput.val(_.search);
          _.selected_tags['Search: ' + _.search] = 'search';
        } catch (err) {}
      }

      var tags = s.matchAll(reg);

      if (typeof blkSelectedFilters != 'undefined') {
        var selected = blkSelectedFilters.split(',');
        tags = [];
        selected.forEach(function (tag) {
          var found = false;
          tag = decodeURIComponent(tag);
          tag = tag.replace('PPLUS', '+');

          _.available_tags.every(function (tagCategory) {
            tagCategory.tags.every(function (availableTag) {
              if (tag == availableTag.tag) {
                tags.push([tag, tag]);
                found = true;
              }

              if (found == true) {
                return false;
              }
              return true;
            });

            if (found == true) {
              return false;
            }
            return true;
          });
        });
      }

      if (tags) {
        tags.forEach(function (tag) {
          tag[1] = decodeURIComponent(tag[1]);
          tag[1] = tag[1].replace('PPLUS', '+');
          _.selected_tags[tag[1]] = tag[1];
        });
      }

      var brands = s.matchAll(brandReg);
      if (brands) {
        brands.forEach(function (tag) {
          var found = false;

          tag[1] = decodeURIComponent(tag[1]);
          tag[1] = tag[1].replaceAll('PPLUS', '+');

          _.available_tags[2].tags.every(function (availableTag) {
            var matchTag = availableTag.tag;
            matchTag = availableTag.tag.replaceAll('%2B', '+');
            matchTag = decodeURIComponent(availableTag.tag);
            if (tag[1].toLowerCase() == matchTag.toLowerCase()) {
              _.selected_brands[matchTag] = availableTag.name;
              found = true;
            }

            if (found == true) {
              return false;
            }
            return true;
          });
        });
      } else if (pathName.indexOf('/brands/') !== -1) {
        // check for /brands/brand.
        var parts = pathName.split('/');
        var brand = parts[2];
        var found = false;

        brand = brand.replaceAll('PPLUS', '+');
        brand = brand.replaceAll('-', ' ');
        brand = decodeURIComponent(brand);
        brand = brand.replaceAll('â€”', '-');
        brand = brand.replaceAll('%2B', '+');

        _.available_tags[2].tags.every(function (availableTag) {
          var matchTag = availableTag.tag;
          matchTag = availableTag.tag.replaceAll('%2B', '+');
          matchTag = decodeURIComponent(availableTag.tag);

          if (brand.toLowerCase() == matchTag.toLowerCase()) {
            _.selected_brands[matchTag] = availableTag.name;
            found = true;
          }

          if (found == true) {
            return false;
          }
          return true;
        });
      }
    };

    this.enableSelectedBrand = function (name, brand) {
      _.clearAbsoluteTags();

      if (typeof _.selected_brands[brand] == 'undefined') {
        _.selected_brands[brand] = name;
      }

      _.route();
    };

    this.clearSelectedBrand = function (brand) {
      if (typeof _.selected_brands[brand.toLowerCase()] != 'undefined') {
        delete _.selected_brands[brand.toLowerCase()];
      }
    };

    this.binaryToggleSelectedBrand = function (category_class, name, brand) {
      //clear all other category tags
      _.available_tags.some(function (category) {
        if (category.class == category_class) {
          category.tags.forEach(function (t) {
            if (t.name != name) {
              _.clearSelectedBrand(t.tag);
            }
          });

          return true;
        }
      });

      _.enableSelectedBrand(name, brand);
    };

    this.clearSelectedTag = function (tag) {
      if (typeof _.selected_tags[tag] != 'undefined') {
        if (_.selected_tags[tag] == 'search') {
          _.search = '';
        }

        delete _.selected_tags[tag];
      }
    };

    this.enableSelectedTag = function (tag) {
      _.clearAbsoluteTags();

      var tags = tag.split(',');
      tags.forEach(function (tag) {
        if (typeof _.selected_tags[tag] == 'undefined') {
          _.selected_tags[tag] = tag;
        }

        if (tag == 'clear') {
          //clear all tags
          _.clearAllSelectedTags();
        }
      });

      _.route();
    };

    this.clearAbsoluteTags = function () {
      _.available_tags.forEach(function (category) {
        category.tags.forEach(function (t) {
          if (typeof t.absolute != 'undefined' && t.absolute == true) {
            _.clearSelectedTag(t.tag);
          }
        });
      });
    };

    this.isTagEnabled = function (tag, selected_tags) {
      var selected_tags =
        typeof selected_tags == 'undefined' ? _.selected_tags : selected_tags;

      var tags = tag.split(',');
      var ret = tags.some(function (tag) {
        var found = Object.keys(selected_tags).some(function (t) {
          if (tag == t) {
            return true;
          }
        });

        if (!found) {
          return true;
        }
      });

      return !ret;
    };

    this.compareTagInputToTag = function (input, tag) {
      var tags = input.split(',');
      return tags.some(function (t) {
        if (t == tag) {
          return true;
        }
      });
    };

    this.binaryToggleSelectedTag = function (category_tags, tag) {
      //clear all other category tags
      category_tags.forEach(function (t) {
        if (!_.compareTagInputToTag(tag, t)) {
          _.clearSelectedTag(t);
        }
      });

      //toggle selected
      _.enableSelectedTag(tag);
    };

    this.buildSelectedTagWidget = function () {
      var output = '';

      for (var tag in _.selected_brands) {
        output +=
          "<li data-brand='" + tag + "'>" + _.selected_brands[tag] + '</li>\n';
      }

      for (var tag in _.selected_tags) {
        output += "<li data-tag='" + tag + "'>" + tag + '</li>\n';
      }

      _.selected_filter_list.html(output);

      $(_.selected_filter_list).on('click', 'li', function () {
        var $this = $(this);
        if (typeof $this.data('brand') != 'undefined') {
          _.clearSelectedBrand($this.html());
        } else {
          _.clearSelectedTag($this.data('tag'));
        }
        _.route();
        return false;
      });
    };

    this.buildTagWidget = function () {
      var output = '';
      _.available_tags.forEach(function (category) {
        //check for hidden categories
        var hidden =
          typeof category.hidden != 'undefined' ? category.hidden : false;
        if (hidden != true) {
          //check for binary only filter category
          var binary =
            typeof category.binary != 'undefined' ? category.binary : false;
          binary = binary == true ? ' binary' : '';

          output +=
            "<li class='filter_category " +
            category.class +
            "'>\n" +
            "<h3 class='filter_cat-title'>" +
            category.name +
            '</h3>\n' +
            "<ul class='filter_cat-list text-small' data-category='" +
            category.class +
            "'>\n";

          var selection_tags = _.selected_tags;

          if (category.name == 'Brand') {
            selection_tags = _.selected_brands;
          }

          category.tags.forEach(function (tag) {
            var selected = '';

            if (_.isTagEnabled(tag.tag, selection_tags)) {
              selected = 'selected ';
            }

            var extra = category.name == 'Brand' ? " data-brand='true'" : '';
            var type = category.name == 'Brand' ? 'brand' : 'tag';
            var cssClass = typeof tag.class != 'undefined' ? tag.class : '';
            var absolute =
              typeof tag.absolute != 'undefined' ? tag.absolute : false;
            absolute = absolute == true ? ' absolute' : '';

            output +=
              "<li>\n<a href='#' class='" +
              selected +
              cssClass +
              binary +
              absolute +
              "' data-" +
              type +
              "='" +
              tag.tag +
              "'" +
              extra +
              '>' +
              tag.name +
              '</a>\n</li>\n';
          });

          output += '</ul>\n</li>\n';
        }
      });

      _.filter_categories.html(output);

      $('a', _.filter_categories).click(function () {
        var $this = $(this);
        var binary = $this.hasClass('binary');
        var category;

        //check for absolute and clear all other tags if absolute
        if ($this.hasClass('absolute')) {
          _.clearAllSelectedTags();
        }

        if (binary) {
          var $ul = $this.parent().parent();
          //remove all other selected items
          $('li a', $ul).not($this).removeClass('selected');
          category = $ul.data('category');
        }

        $this.addClass('selected');

        if (typeof $this.data('brand') != 'undefined') {
          _.selected_brands = [];
          if (binary) {
            _.binaryToggleSelectedBrand(
              category,
              $this.html(),
              $this.data('brand')
            );
          } else {
            _.enableSelectedBrand($this.html(), $this.data('brand'));
          }
        } else {
          if (binary) {
            _.binaryToggleSelectedTag(
              _.getTagsForCategory(category),
              $this.data('tag')
            );
          } else {
            _.enableSelectedTag($this.data('tag'));
          }
        }

        return false;
      });
    };

    this.getTagsForCategory = function (category_class) {
      var tags = [];
      _.available_tags.some(function (category) {
        if (category.class == category_class) {
          category.tags.forEach(function (t) {
            t = t.tag.split(',');
            t.forEach(function (tname) {
              tags.push(tname);
            });
          });

          //make the tag array unique
          tags = _.arrayUnique(tags);

          return true;
        }
      });

      return tags;
    };

    this.init();
    return this;
  };

  $(document).ready(function () {
    var s = new search_filter();
  });
})(jQuery, window, document); /*})'"*/ /*})'"*/

/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS
    factory(require('jquery'));
  } else {
    // Browser globals
    factory(jQuery);
  }
})(function ($) {
  var pluses = /\+/g;

  function encode(s) {
    return config.raw ? s : encodeURIComponent(s);
  }

  function decode(s) {
    return config.raw ? s : decodeURIComponent(s);
  }

  function stringifyCookieValue(value) {
    return encode(config.json ? JSON.stringify(value) : String(value));
  }

  function parseCookieValue(s) {
    if (s.indexOf('"') === 0) {
      // This is a quoted cookie as according to RFC2068, unescape...
      s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
    }

    try {
      // Replace server-side written pluses with spaces.
      // If we can't decode the cookie, ignore it, it's unusable.
      // If we can't parse the cookie, ignore it, it's unusable.
      s = decodeURIComponent(s.replace(pluses, ' '));
      return config.json ? JSON.parse(s) : s;
    } catch (e) {}
  }

  function read(s, converter) {
    var value = config.raw ? s : parseCookieValue(s);
    return $.isFunction(converter) ? converter(value) : value;
  }

  var config = ($.cookie = function (key, value, options) {
    // Write

    if (value !== undefined && !$.isFunction(value)) {
      options = $.extend({}, config.defaults, options);

      if (typeof options.expires === 'number') {
        var days = options.expires,
          t = (options.expires = new Date());
        t.setTime(+t + days * 864e5);
      }

      return (document.cookie = [
        encode(key),
        '=',
        stringifyCookieValue(value),
        options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
        options.path ? '; path=' + options.path : '',
        options.domain ? '; domain=' + options.domain : '',
        options.secure ? '; secure' : '',
      ].join(''));
    }

    // Read

    var result = key ? undefined : {};

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all. Also prevents odd result when
    // calling $.cookie().
    var cookies = document.cookie ? document.cookie.split('; ') : [];

    for (var i = 0, l = cookies.length; i < l; i++) {
      var parts = cookies[i].split('=');
      var name = decode(parts.shift());
      var cookie = parts.join('=');

      if (key && key === name) {
        // If second argument (value) is a function it's a converter...
        result = read(cookie, value);
        break;
      }

      // Prevent storing a cookie that we couldn't decode.
      if (!key && (cookie = read(cookie)) !== undefined) {
        result[name] = cookie;
      }
    }

    return result;
  });

  config.defaults = {};

  $.removeCookie = function (key, options) {
    if ($.cookie(key) === undefined) {
      return false;
    }

    // Must not alter options, thus extending a fresh object...
    $.cookie(key, '', $.extend({}, options, { expires: -1 }));
    return !$.cookie(key);
  };
}); /*})'"*/ /*})'"*/

(function ($, window, document, undefined) {
  var sort_filter = function (opts) {
    var _ = this;
    (this.container = $('#search-filters')),
      (this.sort_categories = $('#sort-categories', _.container)),
      (this.selected_sort_list = $(
        '#sort-filter-group .filter_selected-sort ul',
        _.container
      )),
      (this.sortLabel = $('#sort-label', _.container)),
      (this.sort = 'date'),
      (this.direction = 'desc'),
      (this.sortReg = /(&|\?)?sort=([a-z]+)/i),
      (this.directReg = /(&|\?)?direction=([a-z]+)/i),
      (this.w = window);

    this.parseCurrentSort = function () {
      var s = _.w.location.href.slice(_.w.location.href.indexOf('?') + 1);
      s = decodeURIComponent(s);

      var sort_match = s.match(_.sortReg);
      if (sort_match) {
        _.sort = sort_match[2].toLowerCase();
      }

      var direct_match = s.match(_.directReg);
      if (direct_match) {
        _.direction = direct_match[2].toLowerCase();
      }
    };

    this.labelCurrentSort = function () {
      //find current sort
      var current_sort = $('li', _.sort_categories).find(
        'a[data-sort=' + _.sort + '][data-direction=' + _.direction + ']'
      );

      if (current_sort.length) {
        current_sort.addClass('selected');

        var category = current_sort
          .parents('.filter_category')
          .find('.filter_cat-title')
          .text();
        var label = current_sort.text();
        _.selected_sort_list.html('<li>' + label + '</li>');
        _.sortLabel.html(current_sort.text());
      }
    };

    this.setSortDefaults = function () {
      //check to see if sort has been overridden by query string
      _.parseCurrentSort();

      //save default sort order
      $.cookie('BLKOpticalDefaultSort', _.sort, { expires: 14, path: '/' });
      $.cookie('BLKOpticalDefaultSortDirection', _.direction, {
        expires: 14,
        path: '/',
      });
    };

    this.init = function () {
      _.setSortDefaults();
      _.labelCurrentSort();

      $('a', _.sort_categories).click(function () {
        var $link = $(this);
        _.sort = $link.data('sort');
        _.direction = $link.data('direction');
        _.route();

        return false;
      });
    };

    this.route = function () {
      var search = _.w.location.search;

      //delete current
      search = search.replace(_.sortReg, '');
      search = search.replace(_.directReg, '');

      search += (search == '' ? '?' : '&') + 'sort=' + _.sort;
      search += '&direction=' + _.direction;

      _.w.location.search = search;
      return;
    };

    this.init();
    return this;
  };
  $(document).ready(function () {
    var sortf = new sort_filter();
  });
})(jQuery, window, document); /*})'"*/ /*})'"*/

(function ($) {
  $(document).ready(function () {
    var $filterDropdown = $('.filter_options');

    // Filter Drawer Handler
    $('.filter_title_group').each(function (index, value) {
      var filterTrigger = '.filter_toggle, .filter_toolbar-title h1',
        $this = $(this);

      $(filterTrigger, $this).click(function () {
        var $thisFilterDropdown = $filterDropdown.eq(index);
        var $thisFilterTrigger = $(filterTrigger, $this);

        //close all open filters other than the current
        $filterDropdown.not($thisFilterDropdown).removeClass('is-open');
        $(filterTrigger).not($thisFilterTrigger).removeClass('is-open');

        //toggle the current
        $thisFilterDropdown.toggleClass('is-open');
        $thisFilterTrigger.toggleClass('is-open');
      });
    });

    //category handler
    var catTrigger = '.filter_cat-title',
      catDropdown = '.filter_cat-list';

    // click trigger, toggle it's dropdown
    $(catTrigger).click(function () {
      $(this).siblings(catDropdown).toggleClass('is-open');
    });
  });
})(jQuery); /*})'"*/ /*})'"*/

window.rebindResponsiveImages = function (selector) {
  return false;
}; /*})'"*/ /*})'"*/
$('.product-cat-header.toggle__trigger').click(function () {
  $('.product__info .toggle_description').slideToggle('slow');
});
